import { Typography } from '@mui/material';
import { makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import { Processo } from '../modelo';
import { ViewAlertas } from './escaninho/ViewAlertas';
import { ViewIndicadores } from './escaninho/ViewIndicadores';
import { ViewPartesProcesso } from './escaninho/ViewPartesProcesso';

interface IPropsViewDadosProcessoImportacao {
    processo: Processo;
}


class ViewDadosProcessoImportacao extends React.Component<IPropsViewDadosProcessoImportacao> {
    constructor(props: IPropsViewDadosProcessoImportacao) {
        super(props);

        makeObservable(this, {});
    }

    get processo() {
        return this.props.processo;
    }

    get descricaoClasse() {
        return  ` ${this.processo?.classeJudicial?.descricao}`;
    }

    get numeroCompletoProcesso() {
        return this.processo && ` ${this.processo.numeroProcesso}`;
    }

    render() {
        return (
            <div className="dados-processo">
                <div>
                    <Typography>
                        <Typography component='b' variant='h6' className="titulo" tabIndex={0}>
                            Processo:
                        </Typography>
                        {this.numeroCompletoProcesso}
                    </Typography>
                    <Typography>
                        <Typography component='b' variant='h6' className="titulo" tabIndex={1}>
                            Classe:
                        </Typography>
                        {this.descricaoClasse}
                    </Typography>
                    <ViewPartesProcesso partes={this.processo.partes} />
                    <ViewIndicadores indicadores={this.processo.indicadores} />
                    <ViewAlertas alertas={this.processo.alertas} />

                    <Typography>
                        <Typography component='b' variant='h6' className="titulo" tabIndex={5}>
                            Relator:
                        </Typography>
                        {this.processo?.relator && ` ${this.processo.relator.nome}`}
                    </Typography>
                    <Typography>
                        <Typography component='b' variant='h6' className="titulo" tabIndex={6}>
                            Órgão Julgador:
                        </Typography>
                        {this.processo?.orgaoJulgador && ` ${this.processo.orgaoJulgador.sigla}`}
                    </Typography>
                    <Typography>
                        <Typography component='b' variant='h6' className="titulo" tabIndex={7}>
                            Órgão Julgador Colegiado:
                        </Typography>
                        {this.processo?.orgaoJulgadorColegiado && ` ${this.processo.orgaoJulgadorColegiado.sigla}`}
                    </Typography>
                    {/* <Typography>
                        <Typography component='b' variant='h6' className="titulo" >
                            Data de Autuação:
                        </Typography>
                        {this.processo && this.processo.dataAutuacao && ` ${moment(this.processo.dataAutuacao).format('DD/MM/YYYY')}`}
                    </Typography> */}
                </div>
                {
                    this.processo?.impedimentos?.length ?
                        <div className="div-impedimentos">
                            <Typography component='b' variant='h6' className="titulo" tabIndex={8}>
                                O magistrado tem os seguintes impedimentos:
                            </Typography>
                            <ul>
                                {this.processo?.impedimentos?.map((impedimento, index) => <li key={index}>{impedimento}</li>)}
                            </ul>
                        </div>
                        : null
                }
            </div>
        );
    }
}

export default observer(ViewDadosProcessoImportacao);
